export default "__VITE_ASSET__69d5905e__"